<div class="mb-3 form-group position-relative">
  @if (label) {
    <label class="form-label text-light-black fw-semibold mb-3">
      {{ label }}
      @if (is_required) {
        <span class="text-danger">*</span>
      }
    </label>
  }
  @if (control) {
    <div class="position-relative">
      <!-- @if (!textarea) { -->
      <input
        [type]="inputType"
        class="form-control"
        [placeholder]="placeholder"
        [readonly]="readonly"
        [value]="value"
        (input)="handleInput($event)"
        [formControl]="control"
        [ngClass]="{ 'is-invalid': hasError }"
        [ngStyle]="style ? style : null"
        [attr.maxlength]="maxlength ? maxlength : null"
        [attr.minlength]="minlength ? minlength : null"
      />
      <!-- }  -->
      <!-- @else { 
    <textarea
      class="form-control"
      [placeholder]="placeholder"
      [readonly]="readonly"
      [value]="value"
      (input)="handleInput($event)"
      [formControl]="control"
      rows="7"
      [ngClass]="{ 'is-invalid': hasError }"
      [attr.maxlength]="maxlength ? maxlength : null"
      [attr.minlength]="minlength ? minlength : null"
      [ngStyle]="style ? style : null"
    >
    </textarea>
    }  -->

      @if (type == 'password') {
        <div class="eye-icon" [ngClass]="{ 'has-error': hasError }">
          <img
            src="assets/images/auth/eye-{{ togglePassword ? 'open' : 'close' }}.svg"
            alt="toggle password"
            height="25px"
            width="25px"
            (click)="togglePasswordVisibility()"
          />
        </div>
      }
      @if (hasError) {
        <div class="invalid-feedback">
          @if (isErrorArray) {
            <ul>
              @for (message of errorMessages; track message) {
                <li>{{ message }}</li>
              }
            </ul>
          } @else {
            {{ errorMessages }}
          }
        </div>
      }
      @if (remainingChars !== null) {
        <small class="text-muted d-block mt-1 text-end">
          {{ remainingChars }} characters (min {{ minlength }})
        </small>
      }
    </div>
  } @else {
    <div class="position-relative">
      <input
        [type]="inputType"
        class="form-control"
        [placeholder]="placeholder"
        [readonly]="readonly"
        [disabled]="disabled"
        [value]="currentvalue"
        [ngStyle]="style ? style : null"
      />
    </div>
  }
</div>
